import URI from 'urijs'

export default
function (ngModule) {
    ngModule.directive('productReviewsDocumentCard', [function(){
        return {
            restrict: 'E',
            template: require('./mw-card.html'),
            controllerAs: 'vm',
            controller: 'ProductReviewsDocumentCardController',
            scope: {
                document: '=?',
                displaySettings: '=',
                documentClick: '&',
                overlaySentiment: '&?',
                isNarrowCard: '=',
                showFooter: '=',
                showOpenDocumentIcon: '='
            }
        };
    }])
    .controller('ProductReviewsDocumentCardController', [
        '$scope',
        'GeoService',
        'translationService',
        ProductReviewsDocumentCardController
    ]);

    function ProductReviewsDocumentCardController($scope, GeoService, translationService) {

        var documentClick = function documentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        };

        var update = function update() {
            var author = ($scope
                && $scope.document
                && $scope.document.authors
                && $scope.document.authors[0])
                || { name: translationService.getLocalizedString('Unknown') };

            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.isNarrowCard = $scope.isNarrowCard;
            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;
            this.document = $scope.document;
            this.documentId = $scope.document.id;
            this.mediaType = 'social_reviews';
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;

            if($scope.document.sourceUrl) {
                var uri =  new URI($scope.document.sourceUrl)
                this.avatarImageUrl = `https://shuhari-iconoclast-production.herokuapp.com/favicon?size=48&url=${uri.origin()}`;
            }

            this.avatarLinkUrl = $scope.document.url || $scope.document.redirectUrl;
            this.documentUrl = $scope.document.url || $scope.document.redirectUrl;
            this.sourceName = $scope.document.source;
            this.sourceUrl = $scope.document.sourceUrl;
            this.date = $scope.document.date;
            this.authors = author.name && [{
                name: author.name
            }];

            GeoService.convertCountryCodeToCode3($scope.document.country).then(function (countryCode3) {
                this.countryCode = countryCode3;
            }.bind(this));

            this.bigText = $scope.displaySettings.hitSentence
                ? [($scope.document.matchSentence || $scope.document.tagContextMatchSentence || $scope.document.body)]
                : [];
            this.tags = $scope.displaySettings.displayTags && $scope.document.tags;
            this.keywords = ($scope.displaySettings.keywords && ($scope.document.keywords || $scope.document.tagContextKeywords)) || [];

            this.sentiment = $scope.document.sentiment;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;

            this.onOverlaySentimentClick = $scope.overlaySentiment;
            this.onAvatarClick = documentClick.bind(this, this.avatarLinkUrl);
            this.onSourceIconClick = documentClick.bind(this, this.documentUrl);
            this.onSourceNameClick = documentClick.bind(this, this.documentUrl);
            this.onDocumentOpenClick = documentClick.bind(this, this.documentUrl);
            this.onTitleClick = documentClick.bind(this, this.documentUrl);
        }.bind(this);

        $scope.$watch('displaySettings', update, true);
        $scope.$watch('document', update, true);

        update();
    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/product-document-card.js